import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import LoginModal from "../../components/LoginModal";
import ChangePasswordModal from "../../components/ChangePasswordModal";
import "./SidePanel.css";

export default function SidePanel({ setActivePage, isAuthenticated, hasAccess, hasAnyBoardAccess, loading }) {
  const { user, logout } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  const handleLogout = async () => {
    await logout();
  };

  // New Requests is always accessible (public)
  const handleNewRequests = () => {
    setActivePage("new-requests");
  };

  // Helper to safely check access
  const checkAccess = (resourceType, level = 'view') => {
    if (!isAuthenticated || !hasAccess) return false;
    return hasAccess(resourceType, level);
  };

  // Don't show buttons while loading
  if (loading) {
    return (
      <>
        <aside className="side-panel">
          <div className="panel-handle">⮞</div>
          <div className="panel-buttons">
            <button onClick={handleNewRequests}>New Requests</button>
          </div>
          <div className="panel-auth">
            <button onClick={() => setShowLoginModal(true)} className="panel-login-btn">Login</button>
          </div>
        </aside>
        <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
      </>
    );
  }

  return (
    <>
      <aside className="side-panel">
        <div className="panel-handle">⮞</div>
        <div className="panel-buttons">
          {/* Calendar - only show if authenticated and has access */}
          {checkAccess('calendar', 'view') && (
            <button onClick={() => setActivePage("calendar")}>Calendar</button>
          )}
          
          {/* Manage Calendar - only show if authenticated and has access */}
          {checkAccess('calendar-manage', 'view') && (
            <button onClick={() => setActivePage("manage-calendar")}>Manage Calendar</button>
          )}
          
          {/* Workboards - show if authenticated and has access to ANY board */}
          {isAuthenticated && hasAnyBoardAccess && hasAnyBoardAccess() && (
            <button onClick={() => setActivePage("workboards")}>Workboards</button>
          )}
          
          {/* Admin - only show if authenticated and has access */}
          {checkAccess('admin', 'view') && (
            <button onClick={() => setActivePage("editor")}>Admin</button>
          )}
          
          {/* User Permissions - only show if authenticated and has edit access to admin */}
          {checkAccess('admin', 'edit') && (
            <button onClick={() => setActivePage("user-permissions")}>User Permissions</button>
          )}
          
          {/* Teams & Boards - only show if authenticated and has edit access to admin */}
          {checkAccess('admin', 'edit') && (
            <button onClick={() => setActivePage("teams-boards")}>Teams & Boards</button>
          )}
          
          {/* Reporting - only show if authenticated and has view access to admin */}
          {checkAccess('admin', 'view') && (
            <button onClick={() => setActivePage("reporting")}>Reports</button>
          )}
          
          {/* New Requests - always visible (public) */}
          <button onClick={handleNewRequests}>New Requests</button>
        </div>
        <div className="panel-auth">
          {isAuthenticated ? (
            <>
              <div className="panel-user-name">{user?.name || user?.email}</div>
              <button onClick={() => setShowChangePasswordModal(true)} className="panel-change-password-btn">
                Change Password
              </button>
              <button onClick={handleLogout} className="panel-logout-btn">Logout</button>
            </>
          ) : (
            <button onClick={() => setShowLoginModal(true)} className="panel-login-btn">Login</button>
          )}
        </div>
      </aside>
      <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
      <ChangePasswordModal isOpen={showChangePasswordModal} onClose={() => setShowChangePasswordModal(false)} />
    </>
  );
}
